import React from 'react';
import { KivlopeLogo, UserIcon, MenuIcon, XIcon } from './Icons';

const AppHeader = ({ user, userProfile, onLogout, activeScreen, setScreen, onInfoClick }) => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeMenu = () => setIsMenuOpen(false);

  const handleNav = (screen) => {
    setScreen(screen);
    closeMenu();
  };

  const handleInfo = () => {
    onInfoClick();
    closeMenu();
  };

  const handleLogout = () => {
    onLogout();
    closeMenu();
  };

  return (
    <header className="flex justify-between items-center mb-10 relative">
      {/* Logo Section */}
      <div className="flex items-center space-x-3">
        <KivlopeLogo size={40} />
        <h1 className="text-3xl font-bold text-[#D4AF37] font-serif">kivlope</h1>
      </div>

      {/* Desktop Navigation */}
      <nav className="hidden md:flex flex-grow mx-8 justify-center space-x-8 text-lg">
        <button onClick={() => setScreen('dashboard')} className={`pb-2 ${activeScreen === 'dashboard' ? 'text-[#D4AF37] border-b-2 border-[#D4AF37]' : 'text-[#A0A0A0] hover:text-white'}`}>Dashboard</button>
        <button onClick={() => setScreen('friends')} className={`pb-2 ${activeScreen === 'friends' ? 'text-[#D4AF37] border-b-2 border-[#D4AF37]' : 'text-[#A0A0A0] hover:text-white'}`}>Friends</button>
      </nav>

      {/* Desktop User Actions */}
      <div className='hidden md:flex items-center space-x-4'>
        <button onClick={() => setScreen('profile')} className="text-gray-400 hover:text-white transition-colors"><UserIcon /></button>
        <span className="text-[#A0A0A0] hidden lg:inline">{userProfile?.username ? `@${userProfile.username}` : user.email}</span>
        <button onClick={onInfoClick} className="text-[#A0A0A0] hover:text-white transition-colors">About</button>
        <button onClick={onLogout} className="bg-[#1E1E1E] text-[#EAEAEA] font-bold py-2 px-4 rounded-full hover:bg-gray-700 transition-colors">Logout</button>
      </div>

      {/* Mobile Menu Button */}
      <div className="md:hidden">
        <button onClick={toggleMenu} className="text-[#D4AF37] p-2">
          {isMenuOpen ? <XIcon /> : <MenuIcon />}
        </button>
      </div>

      {/* Mobile Dropdown Menu */}
      {isMenuOpen && (
        <div className="absolute top-full right-0 mt-2 w-64 bg-[#1E1E1E] border border-[#D4AF37]/30 rounded-xl shadow-2xl z-50 p-4 flex flex-col space-y-4 md:hidden animate-fade-in">
          <div className="flex items-center space-x-3 pb-4 border-b border-gray-700">
            <UserIcon className="text-[#D4AF37]" />
            <span className="text-[#EAEAEA] truncate">{userProfile?.username ? `@${userProfile.username}` : 'User'}</span>
          </div>

          <button onClick={() => handleNav('dashboard')} className={`text-left px-2 py-1 ${activeScreen === 'dashboard' ? 'text-[#D4AF37] font-bold' : 'text-[#A0A0A0]'}`}>Dashboard</button>
          <button onClick={() => handleNav('friends')} className={`text-left px-2 py-1 ${activeScreen === 'friends' ? 'text-[#D4AF37] font-bold' : 'text-[#A0A0A0]'}`}>Friends</button>
          <button onClick={() => handleNav('profile')} className={`text-left px-2 py-1 ${activeScreen === 'profile' ? 'text-[#D4AF37] font-bold' : 'text-[#A0A0A0]'}`}>Profile</button>
          <button onClick={handleInfo} className="text-left px-2 py-1 text-[#A0A0A0]">About</button>

          <div className="pt-4 border-t border-gray-700">
            <button onClick={handleLogout} className="w-full bg-red-900/30 text-red-400 font-bold py-2 px-4 rounded-lg hover:bg-red-900/50 transition-colors">Logout</button>
          </div>
        </div>
      )}
    </header>
  );
};

export default AppHeader;
